import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: true,
    error: false,
    data: false,
    active: null,
    count: 0, //used to recall api
    animating: false,
}

const profileListingSlice = createSlice({
    initialState,
    name: "influencer_profile",
    reducers: {
        set_error: (state, action) => {
            state.error = action.payload
            return state
        },
        set_loading: (state, action) => {
            state.loading = action.payload
            return state
        },
        set_data: (state, action) => {
            state.data = action.payload
            return state
        },
        set_active_profile: (state, action) => {
            state.active = action.payload
            return state
        },
        set_count: (state, action) => {
            state.count += 1;
            return state
        },
        
    }
})

export default profileListingSlice.reducer;

export const {
    set_loading,
    set_error,
    set_data,
    set_count,
    set_active_profile,
} = profileListingSlice.actions;
